import React, { FC } from 'react';
import CustomTable from '../../../../tables/CustomTable';
import {
  AifmdOverviewTableData,
  generateAifmdOverviewColumns,
  generateAifmdOverviewData,
} from './table.data';
import { DataObject } from '../../../../../types/redux/data/dataTypes';
import GridItem from '../../../../layout/GridComponents/GridItem';
import { useDemoFundIds } from '../../../../../hooks/useDemoFundIds';
import { demoRowStyle } from '../../../../../utilities/demoFundUtils';

export interface AifmdOverviewTableProps {
  reports: DataObject;
  inputData: DataObject;
  section: string;
  pageId: string;
}

const AifmdOverviewTable: FC<AifmdOverviewTableProps> = (props) => {
  const demoFundIds = useDemoFundIds(props.section, props.pageId);
  const tableData =
    props.inputData.data[0] &&
    props.inputData.data[0].length &&
    props.reports.data.length
      ? generateAifmdOverviewData(
          props.inputData.data[0],
          props.reports.data,
          demoFundIds,
        )
      : [];
  const tableColumns = generateAifmdOverviewColumns();

  return (
    <GridItem card xs={12}>
      <CustomTable<AifmdOverviewTableData>
        options={{
          exportButton: true,
          paging: false,
          rowStyle: demoRowStyle<AifmdOverviewTableData>(),
        }}
        loading={
          props.reports && props.inputData
            ? props.reports.isFetching || props.inputData.isFetching
            : true
        }
        data={tableData}
        columns={tableColumns}
        showToolbar
        id="aifmd_overview_table"
        title="AIFMD Overview"
        toolbarComponents={{
          toolbarTitle: 'AIFMD Overview',
        }}
      />
    </GridItem>
  );
};

export default AifmdOverviewTable;
